import { action } from "satcheljs";
import { INoteEntity } from "sh-models";
import { IPreviewSchedulePageStore } from "../../../sh-application/components/previewSchedulePage";
import { SchedulesViewStateStore } from "../../../sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";

const updateNotes = action(
    "UPDATE_NOTES",
    (
        notesUpdated: INoteEntity[],
        isOptimisticUpdate: boolean,
        viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore
    ) => ({
        notesUpdated: notesUpdated || [],
        isOptimisticUpdate: isOptimisticUpdate,
        viewState: viewState
    })
);

export default updateNotes;
